import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_NODE_URL, UBER_MERCHANT_STATEMENT } from "../../../Constants/Config";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";

const initialState = {
  loading: false,
  statement: null,
  status: false,
  error: "",
};

let abortMerchantStatement = null;

// Per-merchant Uber delivery charge-back statement (Node backend)
export const fetchUberMerchantStatement = createAsyncThunk(
  "uberBilling/fetchUberMerchantStatement",
  async (data, { rejectWithValue }) => {
    try {
      if (abortMerchantStatement) {
        abortMerchantStatement.abort();
      }

      abortMerchantStatement = new AbortController();
      const signal = abortMerchantStatement.signal;

      const { token, ...dataNew } = data;
      const response = await axios.post(
        BASE_NODE_URL + UBER_MERCHANT_STATEMENT,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal,
        }
      );
      if (response.data.status === true) {
        return { statement: response.data.result, status: true };
      }
      return { statement: null, status: false };
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const uberBillingSlice = createSlice({
  name: "uberBilling",
  initialState,
  reducers: {
    updateStateOfUberBilling: (state) => {
      state.statement = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUberMerchantStatement.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchUberMerchantStatement.fulfilled, (state, action) => {
      state.loading = false;
      state.statement = action?.payload?.statement;
      state.status = action.payload.status;
      state.error = "";
    });
    builder.addCase(fetchUberMerchantStatement.rejected, (state, action) => {
      state.loading = false;
      state.statement = null;
      state.error = action.error.message;
    });
  },
});

export const { updateStateOfUberBilling } = uberBillingSlice.actions;
export default uberBillingSlice.reducer;
